// Auto-generated by config/clients/generate-tv-config.js — do not edit

const BRAND_CONFIGS = {
  "hoxxtv": {
    "$schema": "./schema.json",
    "client": "hoxxtv",
    "displayName": "HoxxTV",
    "namespace": "com.hoxxtv.app",
    "urlScheme": "hoxxtv",
    "appBrandEnv": "hoxx",
    "aliases": [
      "hoxx"
    ],
    "domain": "hoxxtv.com",
    "contactEmail": "contato@hoxxtv.com",
    "supportEmail": "hoxxtv@gmail.com",
    "legalName": "HoxxTV",
    "storageKey": "HoxxTV",
    "cdnDomain": "hoxxtv.b-cdn.net",
    "siteDomain": "hoxxtv.com.br",
    "favicon": "favicon.ico",
    "headerIcon": "/assets/hoxxtv/logo.png",
    "colors": {
      "primary": "#f95e14",
      "secondary": "#f95e14",
      "background": "#0D1B2A"
    },
    "brandColors": {
      "--primary-color": "#f95e14",
      "--secondary-color": "#f95e14"
    }
  },
  "hoxx": {
    "$schema": "./schema.json",
    "client": "hoxxtv",
    "displayName": "HoxxTV",
    "namespace": "com.hoxxtv.app",
    "urlScheme": "hoxxtv",
    "appBrandEnv": "hoxx",
    "aliases": [
      "hoxx"
    ],
    "domain": "hoxxtv.com",
    "contactEmail": "contato@hoxxtv.com",
    "supportEmail": "hoxxtv@gmail.com",
    "legalName": "HoxxTV",
    "storageKey": "HoxxTV",
    "cdnDomain": "hoxxtv.b-cdn.net",
    "siteDomain": "hoxxtv.com.br",
    "favicon": "favicon.ico",
    "headerIcon": "/assets/hoxxtv/logo.png",
    "colors": {
      "primary": "#f95e14",
      "secondary": "#f95e14",
      "background": "#0D1B2A"
    },
    "brandColors": {
      "--primary-color": "#f95e14",
      "--secondary-color": "#f95e14"
    }
  },
  "ngk": {
    "$schema": "./schema.json",
    "client": "ngk",
    "displayName": "NetGospel Kids",
    "namespace": "com.netgospelkids.app",
    "urlScheme": "ngkkids",
    "appBrandEnv": "ngk",
    "aliases": [
      "ngk"
    ],
    "domain": "netgospelkids.com",
    "contactEmail": "contato@netgospelkids.com",
    "supportEmail": "contato@netgospelkids.com",
    "legalName": "NetGospel Music",
    "storageKey": "NGK",
    "cdnDomain": "netgospelkids.b-cdn.net",
    "helpFormUrl": "https://netgospel.movidesk.com/form/6182",
    "videoReferer": "https://netgospelprime.com",
    "favicon": "logo-icon.png",
    "headerIcon": "/assets/ngk/logo-icon.png",
    "colors": {
      "primary": "#00BCD4",
      "secondary": "#7C4DFF",
      "background": "#0D1B2A"
    },
    "brandColors": {
      "--darkprimary-color": "#0D1B2A",
      "--primary-color": "#00BCD4",
      "--secondary-color": "#7C4DFF",
      "--accent-color": "#FFD54F"
    }
  }
} as const;

export default BRAND_CONFIGS;
